import { RiSearch2Line } from "react-icons/ri";

const StandardSearch = ({ placeholder, onChange, value }) => {
  return (
    <div className="flex  items-start sticky top-0 bg-white  z-50 ">
      <div className={`relative flex w-full rounded-md p-[1px] border bg-[#EAEAEA] mb-4`}>
        <div className="flex flex-1 items-center bg-[rgba(255, 255, 255, 0.08)] pl-12">
          <input
            type="text"
            className="w-full text-black bg-transparent outline-none border-none  py-2 text-sm font-normal placeholder-gray-400"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        </div>
        <div className="absolute left-2 top-2 text-black ">
          <RiSearch2Line size={20} onClick={() => {}} />
        </div>
      </div>
    </div>
  );
};

export default StandardSearch;
